import React, { Component } from "react";
import { Image } from "react-bootstrap";
import { Container } from "react-bootstrap";
import Slider from "react-slick";
import { portfolioSlick2 } from "./script";

const PortfolioList = [
  {
    link:"https://ucafe-af6d5.firebaseapp.com/",
    category: "Used : React js, React - Hooks, React-Routing, React-Bootstrap, API, Session-storage and Firebase-Authentication (google\facebook).",
    title: "4U cafe-Ecommerce website",
  },
  {
    link:"https://fir-storage-3b177.firebaseapp.com/",
    category: "used : React js, React-Bootstrap, React-Routing, Firebase-Authentication and  Firebase-Real time database.",
    title: "Group Chat Application",
  },
  {
    link:"https://covid-store-c6909.firebaseapp.com/",
    category: "Used : React js, React-Routing and React-Bootstrap",
    title: "Covid Store",
  },
  {
    link:"http://w3cafe.infinityfreeapp.com/login.html",
    category: "Used : HTML, CSS, Javascript, PHP, MYSQL and SQL",
    title: "Food Ordering and Management Websit",
  },
  {
    link:"https://drive.google.com/open?id=1hUWy0siCzdXqCqJFdJUYpJg1MipZ3nfB",
    category: "Used : C++, C, File-handling, Socket-programming",
    title: "Food Ordering and Management System",
  },
  
];

class Portfolio extends Component {
  render() {
    let title = "Discover my project's",
      description =
        "We ensure that every work we do conforms to international best practices.";
    return (
      <React.Fragment>
        <div className="portfolio-wrapper" style={{ background: "#0000" }}>
          <div className="container">
            <div className="row align-items-end">
              <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                <div className="section-title text-center">
                  <h2>{title}</h2>
                </div>
              </div>
            </div>
          </div>
          <div className="portfolio-slick-activation mt--70 mt_sm--40">
            <Slider {...portfolioSlick2}>
              {PortfolioList.map((value, index) => (
                <div className="portfolio" key={index}>
                  <div
                    className="thumbnail-inner"
                    style={{ border: "2px solid #009FFD" }}
                  >
                    {/* <div className={`thumbnail ${value.image}`}></div> */}
                    
                  </div>
                  <div className="content">
                    <Container style={{display:"flex",justifyContent:"center",marginBottom:"10px"}}>
                  <Image src="https://i.giphy.com/media/RJzm826vu7WbJvBtxX/200.webp"  fluid  className="imageproject" />
                  </Container>
                    <div className="inner">
                    
                    <h4>
                        <a href="/portfolio-details">{value.title}</a>
                      </h4>
                      {value.category === "UI/UX Design" ? (
                        <p>
                          UI
                          <span style={{ fontFamily: "QuickSand" }}>
                            <b>\</b>
                          </span>
                          UX Design
                        </p>
                      ) : (
                        <p>{value.category}</p>
                      )}
                      <div className="portfolio-button">
                        <a className="rn-btn" href={value.link}>
                          {index===3?"Customer":"view"}
                        </a>
                      </div>
                    </div>
                    {index===3?<div className="portfolio-button">
                      <br/>
                        <a className="rn-btn" href="http://w3cafe.infinityfreeapp.com/management.html">
                          Management
                        </a>
                      </div>:""}
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default Portfolio;
